import { APP_DOCUMENT, MODULE_DOCUMENTS } from "../constants/modules"

export const getModulesBreadcrumb = (searchUrlParams = {}, _) => {

    return [
        {
            path: `/:project/${APP_DOCUMENT}/${MODULE_DOCUMENTS}/:road`,
            newPath: `${APP_DOCUMENT}?${searchUrlParams.toString()}`,
        },
    ]
}